import React, { Component } from "react";
import "@babel/polyfill";
import styled from "styled-components/macro";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Media from "react-media";

import { MainContext } from "../App.js";

import GlobalStyle from "../Styles/globalStyle";

import Location from "../Components/location";
import Profile from "../Components/profile";
import Length from "../Components/length";
import Usage from "../Components/usage";
import HexChooser from "../Components/hex";
import Price from "../Components/price";

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import Placefiller from "../Components/placeholder.js";
import Breadcrumb from "../Components/breadcrumb.js";
import Popular from "../Components/popular";
import Portal from "../Utils/portal";

class Main extends Component {
  render() {
    if (localStorage.getItem("Country") === null) {
      return (
        <>
          <Router>
            <Route path="/" component={Location} />
          </Router>
        </>
      );
    } else {
      return (
        <>
          <GlobalStyle />
          <Router>
            <Switch>
              <Media query="(max-width: 57em)">
                {matches =>
                  matches ? (
                    <>
                      {/*  Mobile */}
                      <Router>
                        <Wrapper>
                          <Route path="/" component={Header} />
                          <MainContext.Consumer>
                            {context =>
                              context.reset === true ? (
                                <Portal>
                                  <Overlay>
                                    {localStorage.removeItem("Country")}
                                    Country Reset
                                    {setTimeout(() => {
                                      this.forceUpdate();
                                    }, 2000)}
                                  </Overlay>
                                </Portal>
                              ) : null
                            }
                          </MainContext.Consumer>
                          <Breadcrumb />
                          <Route exact strict path="/" component={Profile} />
                          <Route exact strict path="/:bit/" component={Usage} />
                          <Route
                            exact
                            strict
                            path="/:bit/:usage/"
                            component={Length}
                          />
                          <Route
                            exact
                            strict
                            path="/:bit/:usage/:leng/"
                            component={HexChooser}
                          />

                          <Route
                            exact
                            strict
                            path="/:bit/:usage/:leng/:hex/"
                            component={Price}
                          />

                          <Footer />
                        </Wrapper>
                      </Router>
                    </>
                  ) : (
                    <>
                      {/*  Desktop */}
                      <Router>
                        <>
                          <MainContext.Consumer>
                            {context =>
                              context.reset === true ? (
                                <Portal>
                                  <Overlay>
                                    {localStorage.removeItem("Country")}
                                    Country Reset
                                    {setTimeout(() => {
                                      this.forceUpdate();
                                    }, 2000)}
                                  </Overlay>
                                </Portal>
                              ) : null
                            }
                          </MainContext.Consumer>
                          <Route path="/" component={Header} />
                          <Breadcrumb />
                          <BigWrapper>
                            <Wrapper>
                              <Route path="/" component={Profile} />
                              <Route path="/:bit/" component={Usage} />
                              <Route path="/:bit/:usage/" component={Length} />
                              <Route
                                exact
                                strict
                                path="/:bit/:usage/:leng/"
                                component={HexChooser}
                              />
                            </Wrapper>
                            <ScreenDisplay>
                              <Switch>
                                <Route
                                  exact
                                  strict
                                  path="/:bit/:usage/:leng/:hex/"
                                  component={Price}
                                />
                                <Route component={Placefiller} />
                              </Switch>
                            </ScreenDisplay>
                            <Route exact path="/" component={Popular} />
                          </BigWrapper>

                          <Footer />
                        </>
                      </Router>
                    </>
                  )
                }
              </Media>
            </Switch>
          </Router>
        </>
      );
    }
  }
}

export default Main;

const Wrapper = styled.div`
  background: white;
  padding: 0;

  width: 50%;
  @supports (display: grid) {
    margin: 0 auto;
    width: 100%;
    max-width: 25rem;
  }
  height: 100%;
`;

const BigWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  max-width: 90rem;
  margin: 0 auto;

  @supports (display: grid) {
    max-width: 100%;
    display: grid;
    grid-template-columns: 24rem 35rem;
    grid-template-rows: 1fr;
    justify-content: center;
    min-height: calc(100vh - 15rem);
  }

  @media print {
    display: block;
  }
`;

const ScreenDisplay = styled.div`
  width: 50%;
  position: relative;
  @supports (display: grid) {
    width: 100%;
    max-width: 35rem;
  }
  @media print {
    max-width: 100%;
  }
`;
const Overlay = styled.div`
  font-weight: bolder;
  color: #ffffff;

  background: #f67280;
  padding: 1rem;
  display: flex;
  justify-content: center;
  span {
    display: flex;
    flex-direction: column;
    button {
      background: #fff;
      border: none;
      border-radius: 10px;

      display: block;
      padding: 0.5rem 1rem;
      margin: 1rem auto 0.5rem auto;
    }
  }
`;
